import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { User, UserDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getUser(): Observable<User> {
        return this.httpClient.get<UserDto>(`api/v1/me`).pipe(map((response) => new User(response)));
    }
}
